import React, { FC } from 'react';
import { useDerivedLiquidityByIchiInfo } from '@app/state/liquidityByIchiStore';
import { Address } from '@thirdweb-dev/sdk';
import { Currency } from '@cryptoalgebra/kim-sdk';
import { NitroDetails } from '@app/screens/liquidity/AddLiquidityV3/components/NitroDetails';

interface Props {
  poolAddress: Address;
  currencyA: Currency;
  currencyB: Currency;
}

export const IchiPositionsDetails: FC<Props> = ({
  currencyA,
  currencyB,
  poolAddress
}) => {
  const mintInfo = useDerivedLiquidityByIchiInfo(poolAddress);

  if (!mintInfo.nftPoolAddress) {
    return null;
  }

  return (
    <>
      <NitroDetails
        poolAddress={poolAddress}
        currencyA={currencyA}
        currencyB={currencyB}
        nftPoolAddress={mintInfo.nftPoolAddress}
      />
    </>
  );
};
